import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";
import {stat} from "fs";

export type IPerson = {
  id: number;
  name: string,
  eventName: string
  birthdayDate: string;
  emails: Array<string>,
  enableNotification: boolean;
}
export const initialState = {
  persons: []
};


const slice = createSlice({
  name: 'persons',
  initialState,
  reducers: {

    setPersons: (state: IRootState, action: PayloadAction<Array<IPerson>>) => {
      state.persons = action.payload
    },

    addPerson: (state: IRootState, action: PayloadAction<Array<IPerson>>) => {
      state.persons.push(action.payload)
    },

    updatePerson: (state: IRootState, action: PayloadAction<IPerson>) => {
      state.persons.forEach((person: IPerson) => {
        if (person.id === action.payload.id) {
          person.name = action.payload.name
          person.eventName = action.payload.eventName
          person.birthdayDate = action.payload.birthdayDate
          person.emails = action.payload.emails
          person.enableNotification = action.payload.enableNotification
        }
      })
    },
    deletePerson: (state: IRootState, action: PayloadAction<number>) => {
      state.persons = state.persons.filter((person: IPerson) => person.id !== action.payload)
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
